import React from 'react'
import { useTranslation } from 'react-i18next'
import { WidgetGuard } from 'features/types'
import { DashboardWidgetData } from 'features/widget/types'
import { useDashboardWidgetPreWork } from 'hooks/useWidgetState'
import ErrorMessage from 'components/share/ErrorMessage'
import { SentenceFingerprintRetrievalResult } from 'schemas/SentenceFingerprintRetrievalResultSchema'
import { DocumentFingerprintRetrievalResult } from 'schemas/DocumentFingerprintRetrievalResultSchema'
import ErrorCode from 'enums/ErrorCode'

const getErrorCode = (
  data: DashboardWidgetData<DocumentFingerprintRetrievalResult | SentenceFingerprintRetrievalResult>
) => data.results![0].error?.errorCode

const StreamWidgetTopicIndexNotReadyGuard: WidgetGuard = ({ widgetId, children }) => {
  const widgetPreWork = useDashboardWidgetPreWork<
    DocumentFingerprintRetrievalResult | SentenceFingerprintRetrievalResult
  >(widgetId)
  const { t } = useTranslation()

  if (widgetPreWork.some((d) => getErrorCode(d) === ErrorCode.TOPIC_MANAGER_INDEX_NOT_READY_ERROR))
    return <ErrorMessage>{t('topicLoading')}</ErrorMessage>

  return children
}

export default StreamWidgetTopicIndexNotReadyGuard
